import { render, staticRenderFns } from "./StatementList.vue?vue&type=template&id=467b79ea&scoped=true"
import script from "./StatementList.vue?vue&type=script&lang=ts"
export * from "./StatementList.vue?vue&type=script&lang=ts"
import style0 from "./StatementList.vue?vue&type=style&index=0&id=467b79ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467b79ea",
  null
  
)

export default component.exports